import React from "react";
import { defineMessages } from "react-intl";
import { LinkedRow, RowText } from "cci-component";
import { SessionQuery, findOfficesByNameQuery } from "cci-data";
import MutableList from "../../list/MutableList";

const messages = defineMessages({
  searchOffices: {
    id: "searchOffices",
    defaultMessage: "Search Offices"
  }
});

/**
 * Office list page containing the search bar along the top, the office list in the middle and the add button along the bottom.
 */
const List = props => (
  <SessionQuery>
    {({ wrapBusiness }) => (
      <MutableList
        {...props}
        queryName="findOfficesByName"
        query={findOfficesByNameQuery}
        variables={wrapBusiness({ name: "" })}
        filterProperty="name"
        searchPlaceholder={messages.searchOffices}
        newUrl="/offices/new"
        recordRenderer={({ key, style }, rowData) => (
          <LinkedRow
            key={key}
            style={style}
            to={{
              pathname: `/offices/${rowData.id}`
            }}
          >
            <RowText flex={1}>{rowData.contact.alias || rowData.contact.companyName}</RowText>
          </LinkedRow>
        )}
      />
    )}
  </SessionQuery>
);

export default List;
